import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import ReferenceContactPolicyContent from "./ReferenceContactPolicyContent";
import BottomBar from "../BottomBar/BottomBar";
class ReferenceContactPolicy extends Component {
  render() {
    return (
      <div id="referencecontactpolicy" className="main">
        <Helmet>
          <title>Reference Contact Policy | MoneyMonk</title>
          <meta name="description" content="MoneyMonk's policy on the collection and use of reference contact information during the personal loan application process." />
          <link rel="canonical" href="https://moneymonkapp.in/referencecontactpolicy" />
        </Helmet>
        <Navbar imageData={logo} />
        <ReferenceContactPolicyContent />
        <BottomBar />
      </div>
    );
  }
}

export default ReferenceContactPolicy;
